export enum SaleStageStatus {
  InActive = "inactive",
  Active = "active",
  Done = "done"
}
